import { AppGlobalState } from 'modules/types'
import { createBasicSelectors } from 'modules/utils/helpers/createBasicSelectors'

export default {
  ...createBasicSelectors('programSummary'),
  programs: (state: AppGlobalState) => state.programSummary.programs,
  programsFetchProgress: (state: AppGlobalState) => state.programSummary.programsFetchProgress,
  programsFetchErrorDetail: (state: AppGlobalState) => state.programSummary.programsFetchErrorDetail,
}
